import React from 'react';
import classNames from 'classnames';

import { Line } from 'app/page/orders/model/products-summary';
import { Typography } from 'app/components/domain/typography';
import { Variant } from 'app/components/common/typography/typography';

import styles from './summary-line.module.scss';

interface Props {
    line: Line;
    discount?: boolean;
    plan?: boolean;
}

const SummaryLineComponent: React.FC<Props> = (props) => {
    const { line, discount, plan } = props;

    const textVariant: Variant = plan ? 'subtitle3' : 'body1';

    return (
        <div className={classNames(styles.chargeRow, discount && styles.discountLine, plan && styles.planLine)}>
            <Typography component="span" variant={textVariant} className={styles.lineTitle}>
                {line.title}
            </Typography>
            <div className={styles.priceColumn}>
                <Typography component="span" variant={textVariant} className={styles.currency}>
                    {line.priceText}
                </Typography>
                <Typography component="span" variant={textVariant} className={styles.price}>
                    {line.quantity && line.quantity > 1 ? `${line.quantity} x ` : null}
                    {line.amount}
                </Typography>
            </div>
        </div>
    );
};

export { SummaryLineComponent };
